import React from "react";
import LoginButton from "../buttons/loginButton";

const CallToAction = () => {
  return (
    <div className="gray-full-width">
      <h3>March 13, 2025</h3>
      <p>8:00 a.m. - 2:15 p.m.</p>
      <p>Waldorf Astoria, Washington, D.C.</p>
      <LoginButton />
    </div>
  );
};

export default CallToAction;
